const actions = {
    // Settings
    PUBLIC_READ_PRICING_TRANSITION_REQUEST: 'PUBLIC_READ_PRICING_TRANSITION_REQUEST',
    PUBLIC_READ_PRICING_TRANSITION_SUCCESS: 'PUBLIC_READ_PRICING_TRANSITION_SUCCESS',
    PUBLIC_READ_PRICING_TRANSITION_ERROR: 'PUBLIC_READ_PRICING_TRANSITION_ERROR',

    PUBLIC_UPDATE_PRICING_TRANSITION_REQUEST: 'PUBLIC_UPDATE_PRICING_TRANSITION_REQUEST',
    PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS: 'PUBLIC_UPDATE_PRICING_TRANSITION_SUCCESS',
    PUBLIC_UPDATE_PRICING_TRANSITION_ERROR: 'PUBLIC_UPDATE_PRICING_TRANSITION_ERROR',

    PUBLIC_READ_PUBLIC_PLANS_REQUEST: 'PUBLIC_READ_PUBLIC_PLANS_REQUEST',
    PUBLIC_READ_PUBLIC_PLANS_SUCCESS: 'PUBLIC_READ_PUBLIC_PLANS_SUCCESS',
    PUBLIC_READ_PUBLIC_PLANS_ERROR: 'PUBLIC_READ_PUBLIC_PLANS_ERROR',

    PUBLIC_READ_PUBLIC_ADDONS_PACKS_REQUEST: 'PUBLIC_READ_PUBLIC_ADDONS_PACKS_REQUEST',
    PUBLIC_READ_PUBLIC_ADDONS_PACKS_SUCCESS: 'PUBLIC_READ_PUBLIC_ADDONS_PACKS_SUCCESS',
    PUBLIC_READ_PUBLIC_ADDONS_PACKS_ERROR: 'PUBLIC_READ_PUBLIC_ADDONS_PACKS_ERROR',

    PUBLIC_PRICING_TRANSITION_RESET_STATE: 'PUBLIC_PRICING_TRANSITION_RESET_STATE',

    readPricingTransition: (companyId, hash) => ({
        type: actions.PUBLIC_READ_PRICING_TRANSITION_REQUEST,
        companyId,
        hash,
    }),

    updatePricingTransition: (companyId, hash, request) => ({
        type: actions.PUBLIC_UPDATE_PRICING_TRANSITION_REQUEST,
        companyId,
        hash,
        request,
    }),

    readPublicPlans: request => ({
        type: actions.PUBLIC_READ_PUBLIC_PLANS_REQUEST,
        request,
    }),

    readPublicAddonPacks: (include_new = true) => ({
        type: actions.PUBLIC_READ_PUBLIC_ADDONS_PACKS_REQUEST,
        include_new,
    }),

    resetPricingTransitionState: () => ({
        type: actions.PUBLIC_PRICING_TRANSITION_RESET_STATE,
    }),
};
export default actions;
